import { Button, Table, Tag } from 'antd';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import API from 'helpers/API';
import { HeadingH1 } from 'components/ui';
import { getOrderDisplayNo, getOrderStatus, getPaymentMethod } from 'utils/CodeMapper';

const Page = () => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    API.get('/customer/orders').then(({ success, data }) => {
      if (success) {
        setOrders(data.orders ?? []);
      }
    });
  }, []);

  const columns = [
    {
      title: '주문번호',
      dataIndex: 'orderNo',
      render: (_, record) => getOrderDisplayNo(record),
    },
    {
      title: '주문일자',
      dataIndex: 'orderDate',
    },
    {
      title: '수량',
      dataIndex: 'quantity',
    },
    {
      title: '결제방법',
      dataIndex: 'paymentMethod',
      render: (value) => getPaymentMethod(value),
    },
    {
      title: '상태',
      dataIndex: 'status',
      render: (value) => <Tag>{getOrderStatus(value)}</Tag>,
    },
    {
      title: '수신자명',
      dataIndex: 'deliveryName',
    },
    {
      title: '수신자 회사명',
      dataIndex: 'deliveryCompany',
    },
  ];

  return (
    <>
      <HeadingH1 title={'주문이력'} />
      <div style={{ marginBottom: 16 }}>
        <Button type="primary" onClick={() => navigate('/customer/orders/new')}>
          주문하기
        </Button>
      </div>
      <Table
        rowKey={'rid'}
        columns={columns}
        dataSource={orders}
        onRow={(record) => ({
          onClick: () => navigate(`/customer/orders/${record.rid}`),
        })}
      />
    </>
  );
};

export default Page;
